<template>
  <div>
    <HeaderTop ref="shopcar"></HeaderTop>
    <HeaderSearch
      :active="'partsSearch'"
      @getDataListSearch="getDataListSearch"
      :flag="1"
    ></HeaderSearch>
    <Slider></Slider>
    <div style="width: 100%; height: 2px; background: #377cf1"></div>
    <div class="center">
      <div class="header">
        <div class="left">
          <span>配件查询</span>
          <span>&gt;</span>
          <span>{{ searchData.keyword }}</span>
        </div>
        <div class="right">
          <ul>
            <!-- <li @click="headerClick(1)"> -->
            <!-- :class="searchData.area == 1 ? 'checked' : ''" -->
            <!-- <li class="checked">交易专区({{ transactionAmount }})</li> -->
            <!-- <li
              @click="headerClick(2)"
              :class="searchData.area == 2 ? 'checked' : ''"
            >
              咨询专区({{ enquiryAmount }})
            </li> -->
          </ul>
        </div>
      </div>
      <Searchtop ref="searchTop" :obj="obj"></Searchtop>
      <div style="display: flex; justify-content: right; margin-top: 10px">
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          size="small"
          :page-size-opts="[30]"
          show-total
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>
      <!-- 查询区域 -->
      <div class="active">
        <div class="left">
          <ul>
            <li
              @click="synthesisChecked"
              :class="checkNum == 0 ? 'checked' : ''"
            >
              综合排序
            </li>
            <li @click="priceChecked" :class="checkNum == 2 ? 'checked' : ''">
              <span>价格</span>
              <div class="rotate">
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.priceSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.priceSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li>
            <li
              @click="inventoryChecked"
              :class="checkNum == 1 ? 'checked' : ''"
            >
              <span>库存</span>
              <div class="rotate">
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.stockSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.stockSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li>

            <li>
              <span>发货地：</span>
              <Select v-model="addressId" style="width: 140px" filterable>
                <Option
                  v-for="item in cityList"
                  :value="item.id"
                  :key="item.id"
                  @click.native="chioce(item)"
                  >{{ item.name }}</Option
                >
              </Select>
            </li>
          </ul>
        </div>
        <div class="right">
          <Checkbox
            v-model="hasGoods"
            v-if="searchData.area == ''"
            @on-change="getDataList"
            >只显示有货</Checkbox
          >
          <!-- <Checkbox
            v-model="isActive"
            v-if="searchData.area == 1"
            @on-change="isActiveChange"
            >只显示活动</Checkbox
          > -->
        </div>
      </div>
      <!-- 表头 -->
      <Row class="tableHeader" v-if="dataList.length">
        <!-- <Col span="1"></Col> -->
        <Col span="2">商品图片</Col>
        <Col span="5">基本信息</Col>
        <Col span="3">门店</Col>
        <Col span="3">发货地</Col>
        <Col span="2">库存</Col>
        <Col span="3">价格</Col>
        <Col span="3">购买数量</Col>
        <Col span="3">操作</Col>
      </Row>
      <!-- 内容 -->
      <div class="table">
        <transition-group
          name="more"
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-if="dataList.length"
        >
          <div
            class="tableCenter"
            v-for="(item, index) in dataList"
            :key="item.id"
          >
            <Row>
              <!-- <Col span="1"></Col> -->
              <div class="mb10">
                <div class="lm">
                  <!-- <img
                    src="@/assets/images/home/ai.png"
                    alt=""
                    v-show="item.owner || item.source"
                  /> -->
                  <span v-show="item.owner"> {{ item.owner }} </span>
                  <div v-show="item.source" class="w110">
                    {{ item.source }}
                  </div>
                </div>

                <!-- <div class="mb10">
                这是一个测试我也不知道我到底要写多少个东西出来的就看着写吧!
              </div> -->
              </div>
            </Row>
            <Row>
              <!-- <Col span="1">
                <div class="activeBox" v-if="item.type == 1">
                  <span class="iconfont icon-a-zu425"></span>
                  <p>优惠</p>
                </div></Col
              > -->
              <Col span="2" class="flexCenter">
                <img
                  v-if="item.pictureUrl"
                  :src="item.pictureUrl"
                  alt="图片缺失"
                />
                <img
                  v-else
                  src="../../assets/images/shoppingCart/2.png"
                  alt="图片缺失"
                />
              </Col>
              <Col span="5" class="detail">
                <div style="cursor: pointer">
                  <!-- <div class="partType">{{ item.typeName }}</div> -->
                  <div
                    class="partName"
                    @click="goDetails(item)"
                    style="max-width: 195px"
                  >
                    <span class="partType">{{ item.typeName }} </span>
                    {{ item.oeCode }}
                    <!-- </p> -->
                    <!-- <p> -->
                    {{ item.carBrandName }}

                    <!-- </p> -->
                    <!-- <p> -->
                    {{ item.direction }}{{ item.stdNameJp }}{{ item.oilGrade }}
                  </div>
                </div>
                <div class="oe-p" @mouseleave="closeRelevance(index)">
                  OE号：
                  <p
                    @mouseenter="getRelevance(item.partId, index, item)"
                    v-if="item.oemCodes.length"
                  >
                    {{ item.oemCodes[0]
                    }}<i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="item.oemCodes.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.oemCodes.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="item.isShow ? 'show' : ''"
                    >
                      <p v-for="i in item.oemCodes.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                </div>
                <ul style="padding-left: 4px">
                  <li>服务：</li>
                  <li v-if="item.genuineGuarantee">
                    <span class="iconfont icon-a-lujing153"></span>
                    <!-- <p>正品保证</p> -->
                  </li>
                  <!-- <li> -->
                  <li v-if="item.technicalSupport">
                    <span class="iconfont icon-a-ziyuan4"></span>
                    <!-- <p>技术支持</p> -->
                  </li>
                  <!-- <li> -->
                  <li v-if="item.warrantyService">
                    <span class="iconfont icon-a-ziyuan5"></span>
                    <!-- <p>保修服务</p> -->
                  </li>
                  <!-- <li> -->
                  <li v-if="item.returnPromise">
                    <span class="iconfont icon-a-ziyuan21"></span>
                    <!-- <p>退换货承诺</p> -->
                  </li>
                </ul>
              </Col>

              <Col span="3" class="flexCenter">
                <div class="shop">
                  <!-- 这期隐藏不跳转 -->
                  <p @click="goShop(item)" style="cursor: pointer">
                    {{ item.shopName }}
                  </p>
                  <!-- =================？？? -->
                  <!-- <p style="cursor: pointer">
                    {{ item.shopName }}
                  </p> -->
                  <span>{{ item.provinceName }}{{ item.cityName }}</span>
                </div>
              </Col>
              <!-- 发货地 -->
              <Col span="3" class="w120">
                <div class="oe-p" @mouseleave="closeCity(index)">
                  <p
                    class="w122"
                    @mouseenter="getCity(item.partId, index, item)"
                    v-if="item.shipCityStores.length"
                  >
                    {{ item.shipCityStore.city }}
                    {{ item.shipCityStore.name }}
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="item.shipCityStores.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.shipCityStores.length > 1"
                  >
                    <div
                      class="relevanceBox w33"
                      :class="item.isShows ? 'show' : ''"
                    >
                      <p
                        v-for="i in item.shipCityStores"
                        :key="i.index"
                        class="w22"
                        :class="isCity === i.name ? 'isCityed' : ''"
                        @click="checkCITY(i, item)"
                      >
                        {{ i.city }}
                        {{ i.name }}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="2" class="flexCenter"
                >{{ item.stock &lt; 10 ? item.stock : '10+' }}/{{
                  item.unitId
                }}</Col
              >
              <Col span="3"
                ><div class="price">
                  <div v-if="!item.inquiry">
                    <p>￥{{ item.price }}</p>
                    <span
                      v-if="item.type == 1"
                      class="iconfont icon-a-lujing156"
                    ></span>
                    <span v-if="item.type == 1">{{ item.activityTime }}</span>
                  </div>
                  <p v-else>询价</p>
                </div>
              </Col>
              <Col span="3">
                <div class="number">
                  <div class="number-in">
                    <Button
                      class="number-sub"
                      @click="cliSub(item, index)"
                      :disabled="item.Sub"
                      >-</Button
                    >
                    <input
                      oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      :id="index"
                      @blur="BlurNumber(item, index)"
                      v-model="item.maxNum"
                      style="width: 53px; text-align: center; line-height: 31px"
                    />
                    <Button
                      class="number-add"
                      @click="cliAdd(item, index)"
                      :disabled="item.Add"
                      >+</Button
                    >
                  </div>
                  <div class="number-sp" :class="item.isNumber ? 'show' : ''">
                    库存不足
                  </div>
                </div>
              </Col>
              <Col span="3">
                <div class="handle" v-if="tenantId !== item.tenantId">
                  <div class="left">
                    <span
                      style="padding-top: 4px"
                      class="iconfont"
                      :class="
                        item.attention ? 'icon-a-ziyuan1' : 'icon-a-lujing157'
                      "
                      @click="collect(item)"
                    ></span>
                    <div v-if="!item.inquiry" class="regular">
                      <span
                        class="iconfont icon-a-zu420"
                        title="加入购物车"
                        @click="setShopCat(item, index)"
                      ></span>
                    </div>
                    <div v-else class="noregular">
                      <span class="iconfont icon-a-zu420"></span>
                    </div>
                    <xiaopei
                      style="padding-top: 4px"
                      :oppositeTenantId="item.tenantId"
                      :partId="item.partId"
                      ><i class="iconfont icon-a-lujing162"></i
                    ></xiaopei>
                  </div>
                  <div class="right" v-if="item.inquiry == 0">
                    <Button
                      @click="prebuy(item)"
                      :loading="item.buyLoading"
                      type="error"
                      >立即购买</Button
                    >
                  </div>
                  <div class="right" v-if="item.inquiry == 1">
                    <Button @click="enquiry(item)" type="primary"
                      >立即询价</Button
                    >
                  </div>
                </div></Col
              >
            </Row>
          </div>
        </transition-group>
        <!-- 数据为空 -->
        <div class="emptyData" v-if="dataList.length == 0">
          <p>
            <span
              ><i
                ><Icon
                  type="ios-alert-outline"
                  size="17"
                />没找到您想要的数据~</i
              ></span
            >
          </p>
        </div>
        <!-- 加载中 -->
        <div class="demo-spin-container" v-if="spinShow">
          <Spin fix></Spin>
        </div>
      </div>
      <div style="display: flex; justify-content: right">
        <Page
          style="padding: 0 0 10px 0"
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          size="small"
          :page-size-opts="[30]"
          show-total
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>
    </div>
    <Footer></Footer>
    <footerP></footerP>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
  </div>
</template>

<script>
import Slider from '../base/common/slider.vue'
import Searchtop from '../components/searchTop.vue'
import {
  getDataList,
  getListAddress,
  getattention,
  getenquiryqd
} from '@/api/goodsList.js'
// import { awaken } from '@/api/xiaopei/shout.js'
import xiaopei from '@/views/xiaopei/index.vue'
import { listData } from '@/views/base/common/listData.js'
import Footer from '../base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
import HeaderTop from '../base/common/header-top.vue'
import enquirytk from '../base/common/enquirytk.vue'
import HeaderSearch from '../base/common/header-search.vue'
export default {
  mixins: [listData],

  components: {
    Slider,
    Searchtop,
    Footer,
    footerP,
    HeaderTop,
    HeaderSearch,
    xiaopei,
    enquirytk
  },
  data() {
    return {
      obj: {
        o: this.$route.query.partType,
        b: this.$route.query.brandId
      },
      enquirytk: false,
      enquirynum: 1, // 询价数量
      enquirydata: {}, // 询价数据
      loadeqd: false,
      // 下面是尚亚丹写的
      searchContent: '', //搜索内容
      checkNum: 0, // 0/销量 1/库存 2/价格
      inventoryNum: 0, //库存点击次数
      priceNum: 0, //价格点击次数
      brandArr: [], // 品牌数组（回填头部）
      PartsTypeArr: [], // 配件类型数组(回填头部)
      enquiryAmount: 0, //询价数量
      transactionAmount: 0, //交易数量
      addressId: '', // 收货地址
      searchData: {
        area: 1,
        brandId: '',
        current: 1,
        inStock: '',

        keyword: this.$route.query.searchContent,
        leagueId: '',
        partType: '',
        priceSort: '', // 价格查询排序,(1升序，2降序)
        shopId: '',
        size: 30,
        stockSort: '', // 库存查询排序
        // provinceId: '',
        shipCityId: ''
        // areaId: ''
      },

      hasGoods: false,
      isActive: false,

      cityList: []
    }
  },
  created() {
    this.getListAddress()
  },
  watch: {
    // '$route.query.searchContent'() {
    //   // console.log('3333');
    //   // this.pager = {
    //   //   current: 1,
    //   //   size: 10,
    //   //   total: 0
    //   // }
    //   // this.searchData.size = 10
    //   // this.searchData.current = 1
    //   //   // console.log(this.pager);
    //   //   // console.log(this.searchData);
    //   this.getDataListSearch()
    //   // }
    // //   // brandArr() {
    // //   //   // this.$refs.searchTop.getListBrandType(this.brandArr)
    // }
  },
  methods: {
    async collect(item) {
      item.attention = !item.attention
      console.log('收藏')
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      console.log(item.attention)
      const res = await getattention({
        partId: item.partId,
        attention: item.attention
      })
      console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    },
    // 获取了数据
    async getDataList() {
      let n = ''
      n++
      console.log(n)
      this.show = true
      this.spinShow = true
      // this.dataList = []
      this.searchData.keyword = this.$route.query.searchContent
      this.searchData.keyword = this.searchData.keyword.replace(/\s+/g, '')
      this.searchData.inStock = this.hasGoods ? 1 : ''
      // console.log(this.searchData)
      console.log(this.$route.query.partType, this.$route.query.brandId)
      if (this.$route.query.partType && this.$route.query.brandId) {
        this.searchData.partType = this.$route.query.partType
        this.searchData.brandId = this.$route.query.brandId
        this.obj = {
          o: this.$route.query.partType,
          b: this.$route.query.brandId
        }
      }
      this.searchData.shipCityId =
        this.searchData.shipCityId == '-1' ? '' : this.searchData.shipCityId
      let res = await getDataList(this.searchData)
      console.log(res)

      if (res.status == true) {
        this.$nextTick(() => {
          this.brandArr = res.data.partBrandVOList
          this.PartsTypeArr = res.data.partsTypeList
          if (this.$route.query.partType && this.$route.query.brandId) {
          }
          this.$refs.searchTop.getListBrandType(
            this.brandArr,
            this.$route.query.brandId
          )
          this.$refs.searchTop.getListPartsType(
            this.PartsTypeArr,
            this.$route.query.partType
          )
          this.$route.query.partType = undefined
          this.$route.query.brandId = undefined
          this.$refs.searchTop.setStdNameList(res.data.partsStdNameList || [])
          this.dataList = res.data.ipage.records
          this.pager.total = res.data.ipage.total
          this.transactionAmount = res.data.ipage.total
          this.enquiryAmount = res.data.enquiryAmount
          this.getMaxNum()
        })
      } else {
        this.dataList = []
        this.$refs.searchTop.getListBrandType([])
        this.$refs.searchTop.getListPartsType([])
      }

      this.spinShow = false
    },
    async getDataListSearch() {
      console.log('一次')
      this.pager = {
        current: 1,
        size: 30,
        total: 0
      }
      this.searchData.size = 30
      this.searchData.current = 1
      this.searchData.brandId = ''
      this.searchData.partType = ''
      this.$route.query.partType = ''
      this.$route.query.brandId = ''
      // if (i) {
      // } else {
      //   console.log('666666')
      //   this.searchData.size = Number(this.$route.query.size)
      //   this.searchData.current = Number(this.$route.query.current)
      //   this.pager.current = this.searchData.current
      //   this.pager.size = this.searchData.size
      // }

      console.log(this.pager)
      console.log(this.searchData)
      this.show = true
      this.spinShow = true
      // this.dataList = []
      this.searchData.keyword = this.$route.query.searchContent
      this.searchData.keyword = this.searchData.keyword.replace(/\s+/g, '')
      this.searchData.inStock = this.hasGoods ? 1 : ''
      console.log(this.searchData)
      console.log(this.$route.query.searchContent)
      // if (i == 1) {
      //   this.pager = {
      //     current: 1,
      //     size: 10,
      //     total: 0
      //   }
      //   this.searchData.size = 10
      //   this.searchData.current = 1
      // }
      let res = await getDataList(this.searchData)
      console.log(res)

      if (res.status == true) {
        this.$nextTick(() => {
          this.brandArr = res.data.partBrandVOList
          this.PartsTypeArr = res.data.partsTypeList
          this.$refs.searchTop.getListBrandType(this.brandArr,-1)
          this.$refs.searchTop.getListPartsType(this.PartsTypeArr,-1)
          this.dataList = res.data.ipage.records
          this.pager.total = res.data.ipage.total
          this.transactionAmount = res.data.ipage.total
          this.enquiryAmount = res.data.enquiryAmount
          this.getMaxNum()
        })
      } else {
        this.dataList = []
        this.$refs.searchTop.getListBrandType([])
      }

      this.spinShow = false
    },
    // 获取收货地址
    async getListAddress() {
      let res = await getListAddress()
      console.log(res)
      // this.cityList = res.data.list
      // this.cityList.push({ countyId: '', cityId: '', county: '全部' })
      this.cityList = res.data
      this.cityList.unshift({ id: '-1', name: '全国' })
      // res.data.forEach((item, index) => {
      // if (item.preferred == 1) {
      //   this.$nextTick(() => {
      this.addressId = '-1'
      //   })
      //   // this.searchData.provinceId = this.cityList[index].provinceId
      this.searchData.shipCityId = this.addressId
      //   // this.searchData.areaId = this.cityList[index].countyId
      // } else {

      // }
      // })

      this.getDataList()
    }, //
    // 改变收货地址
    chioce(item) {
      console.log(this.addressId)
      // this.searchData.provinceId = item.provinceId
      this.searchData.shipCityId = item.id
      // this.searchData.areaId = item.countyId
      this.changeListsBtn()
    },

    // 切换专区
    headerClick(num) {
      this.searchData.area = num
      if (num == 1) {
        this.hasGoods = false
      } else {
        this.hasGoods = true
      }
      this.checkNum = 0
      this.inventoryNum = 0
      this.searchData.stockSort = ''
      this.priceNum = 0
      this.searchData.priceSort = ''
      this.changeListsBtn()
    },
    // 立即询价
    enquiry(item) {
      console.log(item)
      // this.enquirytk = true
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
      // this.enquirydata = item
      console.log(this.enquirydata)
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    }
    // // 立即询价数量
    // changexjNum(value) {
    //   console.log(value)
    // },
    // // 询价确定
    // async enquiryqd() {
    //   this.loadeqd = true
    //   let data = {
    //     enquiryNum: this.enquirynum,
    //     offerTid: this.enquirydata.tenantId,
    //     offerTname: this.enquirydata.shopName,
    //     partId: this.enquirydata.partId
    //   }
    //   const res = await getenquiryqd(data)
    //   this.loadeqd = false
    //   if (res.status) {
    //     this.$refs.shopcar.getenquirydata()
    //     this.enquirytk = false
    //     this.$Message.success('询价成功')
    //   }
    // },
    // // 询价取消
    // enquiryqx() {
    //   this.enquirytk = false
    // }
  }
}
</script>

<style lang="less" scoped>
@import '../supportself/index.less';
@import './index.less';
</style>
